<tds-header>
  <tds-header-hamburger
    [attr.aria-label]="'header.mobileMenuAria' | translate"
    aria-haspopup="true"
    aria-expanded="false"
    [tdsAriaLabel]="'header.mobileMenuLabel' | translate"
    (click)="toggleMobileSideMenu()">
  </tds-header-hamburger>
  <tds-header-title>
    TVMS <span class="env-tip">{{ environmentLabel }}</span>
  </tds-header-title>

  @if(hasMultipleRoles()) {
    <tds-header-dropdown slot="end" id="e2eRoleSwitch">
      <span slot="label">{{ getCurrentRole() | roleTranslate }}</span>
      <tds-header-dropdown-list>
        @for(role of availableRoles(); track role) {
          <tds-header-dropdown-list-item>
            <a (click)="onRoleChange(role)" 
               [class.selected]="getCurrentRole() === role"
               style="cursor: pointer;">
              <div class="role-item">
                <span class="role-name">{{ role | roleTranslate }}</span>
                @if(getCurrentRole() === role) {
                  <span class="role-indicator">✓</span>
                }
              </div>
            </a>
          </tds-header-dropdown-list-item>
        }
      </tds-header-dropdown-list>
    </tds-header-dropdown>
  } @else {
    <tds-header-dropdown slot="end" id="e2eRoleSwitch">
      <span slot="label">{{ getCurrentRole() | roleTranslate }}</span>
      <tds-header-dropdown-list size="lg">
        <tds-header-dropdown-list-item>
          <span class="single-role-hint">{{ getSingleRoleHint() }}</span>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>
  }

  <!-- translation switch section -->
  <tds-header-dropdown id="languageSwitch" slot="end" class="language-dropdown" size="sm" [attr.aria-label]="'header.languageDropdown' | translate">
    <span slot="label">
      {{ currentLanguage() === 'en' ? 'EN' : '中文' }}
    </span>
    <tds-header-dropdown-list>
      @for (option of languageOptions; track $index) {
        <tds-header-dropdown-list-item>
            <a (click)="setLanguage(option.code)" 
              [class.selected]="currentLanguage() === option.code"
            style="cursor: pointer;">
          <div class="role-item">
            <span class="role-name">{{ option.label }}</span>
            @if(currentLanguage() === option.code) {
              <span class="role-indicator">✓</span>
            }
          </div>
          </a>
        </tds-header-dropdown-list-item>
      }
    </tds-header-dropdown-list>
  </tds-header-dropdown>
  @if(showFullscreenButton()) {
    <tds-header-item slot="end">
      <!-- fullscreen button -->
      <tds-icon
        name="expand"
        size="20"
        (click)="toggleFullscreen()"
        style="cursor: pointer; color: white;"
        [attr.aria-label]="'header.fullscreen' | translate">
      </tds-icon>
    </tds-header-item>
  }

  <!-- user profile section -->
  <tds-header-dropdown
    slot="end"
    no-dropdown-icon
    id="e2eProfileBtn"
    class="demo-hide demo-lg-show"
    [attr.aria-label]="'header.profileDropdown' | translate">
    <tds-icon
      slot="icon"
      name="profile"
      size="24"
      color="blue-700"
    ></tds-icon>
    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user
        [header]="profile.name"
        [subheader]="profileJobTitle()"
      >
      </tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item>
        <a>
          <div class="tds-u-pl1 tds-body-02"><strong>{{profile.email}}</strong></div>
        </a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item>
        
          <tds-button variant="ghost" id="e2eLogoutBtn" (click)="logout()" [text]="'header.logout' | translate" >
            
          </tds-button>
        
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-brand-symbol
    slot="end"
    placement="end">
    <a
      [attr.aria-label]="'header.brandAria' | translate"
      routerLink="/"></a>
  </tds-header-brand-symbol>
</tds-header>
